import type {operations} from "~/types/api-types";
import {apiFetcher} from "~/lib/fetchers";

export type ContactEmailRequest =
  operations["sendRequest"]["requestBody"]["content"]["application/json"];

export async function postEmailRequest(request: ContactEmailRequest) {
  return apiFetcher("/public/contact/email", {
    method: "POST",
    body: { ...request },
  });
}
